<template>
  <v-container class="text-center" fluid>
    <v-card class="elevation-10">
      <v-card-title class="justify-center display-1">Gravar Treino</v-card-title>
      <v-card-text>
        <v-img height="100%" src="@/assets/images/map.png"></v-img>
      </v-card-text>
      <v-card-actions class="justify-center pb-5">
        <v-btn v-model="btnBike" class="mt-5 mr-4" fab large :outlined="outlinedBike" :color="colorBike" @click="clickProfile(1)">
          <v-icon dark>mdi-bike</v-icon>
        </v-btn>
        <v-btn v-model="btnRun" class="mt-5 ml-4" fab large :outlined="outlinedRun" :color="colorRun" @click="clickProfile(2)">
          <v-icon dark>mdi-run</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="elevation-10 mt-5">
      <v-card-text class="display-2">
        {{formattedElapsedTime}}
      </v-card-text>
      <v-card-actions class="justify-center pb-5">
        <v-btn v-model="btnStart" class="mt-5" fab large :outlined="outlinedBike" :color="colorBike" @click="start" v-show="!started" transition="fade-transition">
          <v-icon dark>mdi-play</v-icon>
        </v-btn>
        <v-btn v-model="btnStop" class="mt-5" fab large :outlined="outlinedBike" :color="colorBike" @click="stop" v-show="started">
          <v-icon dark>mdi-stop</v-icon>
        </v-btn> 
        <!-- <v-btn v-model="btnStop" class="mt-5" fab large :outlined="outlinedBike" :color="colorBike" @click="reset" v-show="started">
          <v-icon dark>mdi-restart</v-icon>
        </v-btn>  -->
      </v-card-actions>
    </v-card>
  </v-container>
  
</template>

<script>


export default { 

  props: {
    source: String
  },
  data: () => ({

      //timer:
      elapsedTime: 0,
      timer: null,
      btnStart : null,
      btnStop : null,
      started : false,

      btnBike : null,
      btnRun : null,
      colorBike : 'primary',
      colorRun : 'grey lighthen-2',
      outlinedBike : false,
      outlinedRun : true,

  }),
  computed: {
    formattedElapsedTime() {
      const date = new Date(null);
      date.setSeconds(this.elapsedTime / 1000);
      var utc = date.toUTCString();
      //var seconds = utc.substr(utc.indexOf(":") - 2, 8) / 1000;
      return utc.substr(utc.indexOf(":") - 2, 8);
    }
  },
  methods : {
      clickProfile(val){
          switch(val){
              case 1 :
                  this.colorRun = 'grey lighten-1';
                  this.outlinedRun = true;
                  this.colorBike = 'primary';
                  this.outlinedBike = false;
                  break;
              case 2 :
                  this.colorRun = 'primary';
                  this.outlinedRun = false;
                  this.colorBike = 'grey lighten-1';
                  this.outlinedBike = true;
                  break;    
          }
      },
      start() {
        this.timer = setInterval(() => {
          this.elapsedTime += 1000;
        }, 1000);
        this.started = true;
      },
      stop() {
        clearInterval(this.timer);
        this.started = false;
      },
      reset() {
        this.elapsedTime = 0;
      }
  }
};
</script>